module.exports = __webpack_public_path__ + "static/media/billing.9e2cfa75.svg";